/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import { CourtSearch } from "./CourtBookingSelect";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Button } from "../../../components";
import { CourtBookingCustomerDetails } from "./CourtBookingCustomerDetails";
import { toast } from "react-toastify";


const AddCourtBooking = () => {
  const { SelectedFacility } = useAppSelector((state) => state.facilityList);
  const { name } = useAppSelector((state) => state.verifiedUser.UserRole.role);
  const [currentStep, setCurrentStep] = useState(0);
  const [courtBookingData, setCourtBookingData] = useState({
    bookingType: name !== "OFFICE_ADMIN" ? "" : "individual",
    facilityId: SelectedFacility ? SelectedFacility : "",
    sportId: "",
    courtId: "",
    selectedSlots: [],
    gender: "",
    phone: "",
    companyName: "",
    firstName: "",
    lastName: "",
    gstNumber: "",
    email: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    country: "India",
    pincode: "",
    landmark: "",
    latitude: null,
    longitude: null,
    isIgstTax: "false",
    discount: "",
    paymentMode: "instant",
    paymentMethod: "cash",
  });

  useEffect(() => {
    setCourtBookingData({
      ...courtBookingData,
      facilityId: SelectedFacility || "",
      sportId: "",
      courtId: "",
      selectedSlots: [],
    });
    if (SelectedFacility === "") {
      toast.error("Select Facility");
    }
  }, [SelectedFacility]);

  const handleBack = () => {
    setCurrentStep((_oldVal) => {
      if (_oldVal > 0) {
        return --_oldVal;
      } else {
        return _oldVal;
      }
    });
  };

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            {currentStep !== 0 && (
              <>
                <Row>
                  <Col className="text-start">
                    <Button
                      type="button"
                      bname="Back"
                      name="back"
                      id="back"
                      className="btn btn-primary rounded-1 me-3"
                      onClick={handleBack}
                    ></Button>
                  </Col>
                </Row>
                <hr />
              </>
            )}
            {currentStep === 0 && (
              <CourtSearch
                currentStep={currentStep}
                courtBookingData={courtBookingData}
                setCourtBookingData={setCourtBookingData}
                name={name}
                setCurrentStep={setCurrentStep}
              />
            )}
            {currentStep === 1 && (
              <CourtBookingCustomerDetails
                courtBookingData={courtBookingData}
                setCourtBookingData={setCourtBookingData}
                name={name}
              />
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};
export { AddCourtBooking };
